import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, Zap } from 'lucide-react';
export function SistemaPro() {
  const comparison = [{
    sit: 'Llega consulta a las 3AM',
    sin: 'La perdés o respondés dormido',
    con: 'El sistema responde solo'
  }, {
    sit: 'Cliente pagó por MP',
    sin: 'Confirmás a mano y registrás',
    con: 'El sistema lo hace en 10 segundos'
  }, {
    sit: 'Querés tomarte 3 días',
    sin: 'El negocio para',
    con: 'El sistema sigue operando'
  }, {
    sit: 'Necesito saber cuánto vendí hoy',
    sin: 'Entro a la planilla y sumo',
    con: 'Dashboard automático en tiempo real'
  }, {
    sit: 'Quiero hacer seguimiento de leads',
    sin: 'Me olvido o no tengo tiempo',
    con: 'El sistema envía los mensajes solo'
  }, {
    sit: 'Un cliente se quejó',
    sin: 'Respondo cuando veo el mensaje',
    con: 'El sistema responde y te alerta'
  }];
  const includes = ['Auditoría completa de fugas de tiempo y dinero', '5 SOPs (procesos documentados) con IA', 'Notion como cerebro central del negocio', 'Blueprint 1: Consultas → Venta automática', 'Blueprint 2: Post-venta y reclamos automáticos', 'Blueprint 3: Cobranzas con Mercado Pago automáticas', 'La semana tipo del dueño libre (4 horas reales)', 'Dashboard de control dominical de 30 minutos', 'Plan de libertad a 90 días', 'Diagramas de flujo para Make.com', 'Prompts de sistema para cada automatización'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-236">
      <div className="text-center mb-12" data-id="element-237">
        <h2 className="text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-238">
          <Zap className="text-brand-gold w-8 h-8" data-id="element-239" />
          🕊️ ¿QUÉ AGREGA EL SISTEMA EMPRESARIO PRO?
        </h2>
      </div>

      <div className="overflow-x-auto mb-16 rounded-2xl border border-white/10" data-id="element-240">
        <table className="w-full text-left border-collapse" data-id="element-241">
          <thead data-id="element-242">
            <tr className="bg-white/5" data-id="element-243">
              <th className="p-4 border-b border-white/10 text-gray-300 font-medium" data-id="element-244">
                Situación en tu negocio
              </th>
              <th className="p-4 border-b border-white/10 text-brand-red font-bold" data-id="element-245">
                ❌ Sin Sistema Pro
              </th>
              <th className="p-4 border-b border-white/10 text-brand-green font-bold" data-id="element-246">
                ✅ Con Sistema Pro
              </th>
            </tr>
          </thead>
          <tbody data-id="element-247">
            {comparison.map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-248">
                <td className="p-4 text-gray-300" data-id="element-249">{row.sit}</td>
                <td className="p-4 text-gray-400" data-id="element-250">{row.sin}</td>
                <td className="p-4 text-white font-medium" data-id="element-251">{row.con}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="bg-brand-gold/5 border border-brand-gold/20 rounded-3xl p-8 md:p-10" data-id="element-252">
        <h3 className="text-2xl font-bold text-brand-gold mb-8 text-center" data-id="element-253">
          ✅ El Sistema Empresario Pro incluye
        </h3>
        <div className="grid md:grid-cols-2 gap-4" data-id="element-254">
          {includes.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-3" data-id="element-255">
              <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-256" />
              <span className="text-gray-200" data-id="element-257">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}